import { Source, SourceName } from "./sources";
import { Trigger, TriggerName } from "./triggers";

type IDefaultSources = {
  [k in SourceName]: Source;
};

export const DEFAULT_SOURCES: IDefaultSources = {
  [SourceName.GET_FIRST_ORDER]: {
  // Once we have configured all the remaining sign up backend checkout logic to log the
  // user in via the checkouts (namely scoop, influencer and breeder checkouts)
  // we can remove this source entirely, as we shouldn't be using this endpoint to
  // log people in, it's not secure
    component: SourceName.GET_FIRST_ORDER,
  },
  [SourceName.GET_POST_CHECKOUT_CHARGES]: {
    component: SourceName.GET_POST_CHECKOUT_CHARGES,
  },
};

type ITriggerSourceDependencies = {
  [k in TriggerName]: SourceName[];
};

/*
These triggers are called in storyblok pages. If you go tot he page and look under meta data
You can see them being called
*/
export const TRIGGER_SOURCE_DEPENDENCIES: ITriggerSourceDependencies = {
  [TriggerName.POST_CHECKOUT_GTM]: [ SourceName.GET_POST_CHECKOUT_CHARGES ],

  // Once we have configured all the remaining sign up backend checkout logic to log the
  // user in via the checkouts (namely scoop, influencer and breeder checkouts)
  // we can remove this trigger entirely - as we shouldn't be using these triggers to
  // sign people in - and definitely not via a tracking endpoint
  [TriggerName.POST_CHECKOUT_AUTH_SIGN_IN]: [ SourceName.GET_FIRST_ORDER ],
  [TriggerName.POST_CHECKOUT_MENTION_ME]: [ SourceName.GET_POST_CHECKOUT_CHARGES ],
  [TriggerName.KLAVIYO_TRACK_PAGE_VISITED]: [],
  [TriggerName.WONDERING_TRIGGER]: [],
};

/**
 * Given the provided triggers and data sources from storyblok, populate additional
 * sources that are required. e.g.
 * T1 requires S1 and S2
 * T2 requires S1 and S3
 * and S1 and S2 are explicitly provided
 * then we "autofill" an S3 using a default S3
 * and return [ S1, S2, S3 ]
 * @param triggers
 * @param providedSources
 */
export function computeRequiredDefaultSources(
  triggers: Trigger[] = [],
  providedSources: Source[] = [],
): Source[] {

  const requiredSourceNames = new Set(triggers.flatMap((t) => TRIGGER_SOURCE_DEPENDENCIES[t.component]));

  const providedSourceNames = providedSources.map((s) => s.component);

  const additionalSourceNamesRequired = [ ...requiredSourceNames ].filter((s) => !providedSourceNames.includes(s));

  const defaultSourcesRequired = additionalSourceNamesRequired.map((name) => DEFAULT_SOURCES[name]);

  return [ ...providedSources, ...defaultSourcesRequired ];
}
